<template>
  <el-form-item label="默认值">
    <el-input type="text" v-model.trim="optionModel.defaultValue" :placeholder="optionModel.defaultValuePlaceholder || ''"
      @change="emitDefaultValueChange"></el-input>
  </el-form-item>
</template>

<script>
import propertyMixin from "@/components/form-designer/setting-panel/property-editor/propertyMixin"

  export default {
    name: "radio-defaultValue-editor",
    mixins: [propertyMixin],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>
